// extracted by mini-css-extract-plugin
export default {"darkNavbarColorModeToggle":"darkNavbarColorModeToggle_wZ1H"};